// ═══════════════════════════════════════════════════════════════
// SCHEMA v5 CONSTANTS — PixAlloy v0.8
// ═══════════════════════════════════════════════════════════════
// NOTE: Command IDs below MUST match schema.ts. Run `npx tsx scripts/codegen.ts`
// to regenerate generated-commands.js, then check for drift.
// TODO: In the next major version, import C directly from generated-commands.js
//       and delete the hand-written C object below.

// Command types
export const C = {
  UNDO:1,REDO:2,LAYER_ADD:3,LAYER_DEL:4,FILTER:6,STROKE_ON:7,STROKE_OFF:8,FLATTEN:9,
  LAYER_CLR:11,LAYER_UP:12,LAYER_DN:13,SEL_RECT:20,SEL_ELLIPSE:21,SEL_CLR:25,
  TFM_BEGIN:30,TFM_APPLY:31,TFM_CANCEL:32,TFM_SEL_BEGIN:33,TFM_SEL_APPLY:34,TFM_UPDATE:35,COPY:40,PASTE:41,CUT:43,CROP:42,MOVE:50,
  VIS:200,TEXT_ADD:60,SEL_ALL:61,SEL_INV:62,TEXT_UPDATE:63,FX_UPDATE:70,
  LAYER_OP:80,LAYER_BLEND:81,MERGE_DOWN:82,MASK_ADD:90,MASK_DEL:91,MASK_TOGGLE:92,MASK_LINK:93,
  SEL_LASSO:26,SEL_WAND:27,SEL_FEATHER:28,SEL_POLY:29,
  FILL:100,RUBBER_STAMP_SET:101,FILL_COLOR:102,
  IMG_FLIP_H:110,IMG_FLIP_V:111,IMG_ROT90:112,IMG_ROT180:113,IMG_RESIZE:114,CANVAS_SIZE:115,
  LEVELS:120,LAYER_REORDER:121,ADJ_LAYER_ADD:130,ADJ_LAYER_UPDATE:131,
  HIST_JUMP:140,HUESAT_FILTER:141,GAUSS_BLUR:142,COLOR_BALANCE:143,SEL_FROM_ALPHA:144,
  GROUP_ADD:150,GROUP_TOGGLE:151,LAYER_RENAME:152,CONTENT_FILL:153,
  GROUP_MOVE_IN:154,GROUP_MOVE_OUT:155,PEN_TO_SEL:160,PEN_STROKE:161,PEN_FILL:162,
  // v0.8 additions
  ZOOM_FIT:170,DUPLICATE_LAYER:171,VECTOR_LAYER_ADD:180,VECTOR_LAYER_UPDATE:181,
  // Phase 4: Retouching
  SPOT_HEAL:190,RED_EYE:191,FREQ_SEP:192,
  // Phase 8: Advanced Transform & Selection
  LAYER_FLIP_H:200,LAYER_FLIP_V:201,SEL_COLOR_RANGE:202,
};

// Tool IDs
export const T = {
  BRUSH:0,ERASER:1,EYEDROP:2,STAMP:6,SEL_RECT:7,SEL_ELLIPSE:8,WAND:10,
  MOVE:11,TRANSFORM:12,CROP:13,PAN:14,TEXT:15,LASSO:16,POLY_LASSO:17,
  FILL:18,RUBBER_STAMP:19,DODGE:20,BURN:21,DISTORT:22,ZOOM:23,GRADIENT:24,PEN:25,
  // Phase 4: Retouching tools
  SPOT_HEAL:26,RED_EYE:27,
};

// Brush tip type names — single source of truth for tip index → string mapping
export const TIP_NAMES = ["round","square","scatter","texture","flat","hair","grass","splatter","spray"];

// Filter IDs
export const FLT = {AUTO:0,BLUR:1,SHARP:2,GRAY:3,INVERT:4,SEPIA:5,VIGNETTE:6,NOISE:7,HUESAT:8,
  // Phase 5
  EMBOSS:9,EDGE:10,POSTERIZE:11,THRESHOLD:12,CHROMATIC:13,PIXELATE:14};

// Adjustment layer types
export const ADJ = {
  BRIGHTNESS:"brightness",LEVELS:"levels",HUESAT:"huesat",
  INVERT:"invert",CURVES:"curves",COLORBAL:"colorbal",
  // Phase 6
  VIBRANCE:"vibrance",CHANNEL_MIX:"channelmix",BW_MIX:"bwmix",
  SELECTIVE:"selective",GRAD_MAP:"gradmap",SHADOW_HL:"shadowhl",
};

// Default params for each adjustment type
export const ADJ_DEFAULTS = {
  [ADJ.BRIGHTNESS]:{brightness:0,contrast:0},
  [ADJ.LEVELS]:{inBlack:0,inWhite:255,gamma:1.0,outBlack:0,outWhite:255},
  [ADJ.HUESAT]:{hue:0,saturation:0,lightness:0},
  [ADJ.INVERT]:{},
  [ADJ.CURVES]:{points:[[0,0],[64,64],[128,128],[192,192],[255,255]],channel:"master"},
  [ADJ.COLORBAL]:{shadowR:0,shadowG:0,shadowB:0,midR:0,midG:0,midB:0,highR:0,highG:0,highB:0,preserveLum:true},
  // Phase 6
  [ADJ.VIBRANCE]:{amount:0},
  [ADJ.CHANNEL_MIX]:{rr:100,rg:0,rb:0,gr:0,gg:100,gb:0,br:0,bg:0,bb:100},
  [ADJ.BW_MIX]:{red:40,green:34,blue:26},
  [ADJ.SELECTIVE]:{range:"reds",cyan:0,magenta:0,yellow:0,black:0},
  [ADJ.GRAD_MAP]:{stops:[{pos:0,color:"#000000"},{pos:1,color:"#ffffff"}]},
  [ADJ.SHADOW_HL]:{shadows:0,highlights:0,tonalWidth:50},
};

export const ADJ_LABELS = {
  [ADJ.BRIGHTNESS]:"Brightness/Contrast",
  [ADJ.LEVELS]:"Levels",
  [ADJ.HUESAT]:"Hue/Saturation",
  [ADJ.INVERT]:"Invert",
  [ADJ.CURVES]:"Curves",
  [ADJ.COLORBAL]:"Color Balance",
  // Phase 6
  [ADJ.VIBRANCE]:"Vibrance",
  [ADJ.CHANNEL_MIX]:"Channel Mixer",
  [ADJ.BW_MIX]:"Black & White",
  [ADJ.SELECTIVE]:"Selective Color",
  [ADJ.GRAD_MAP]:"Gradient Map",
  [ADJ.SHADOW_HL]:"Shadow/Highlight",
};

// Blend modes: UI label → canvas globalCompositeOperation
export const BLEND_MAP = {
  "Normal":"source-over","Multiply":"multiply","Screen":"screen","Overlay":"overlay",
  "Darken":"darken","Lighten":"lighten","Difference":"difference",
  "Color Dodge":"color-dodge","Color Burn":"color-burn","Hard Light":"hard-light","Soft Light":"soft-light",
};
export const BLENDS = Object.keys(BLEND_MAP);

// Curves presets
export const CURVE_PRESETS = {
  linear:{label:"Linear",points:[[0,0],[255,255]]},
  scurve:{label:"S-Curve (contrast)",points:[[0,0],[64,20],[128,128],[192,235],[255,255]]},
  inverse:{label:"Inverse (negative)",points:[[0,255],[255,0]]},
  highkey:{label:"High Key (bright)",points:[[0,30],[128,180],[255,255]]},
  lowkey:{label:"Low Key (dark)",points:[[0,0],[128,76],[255,225]]},
  fadedfilm:{label:"Faded Film",points:[[0,30],[64,60],[128,130],[192,200],[255,230]]},
};

// Canvas size anchor positions — maps to pixel offset from center
export const ANCHORS = {
  tl:"top-left",tc:"top-center",tr:"top-right",
  ml:"middle-left",mc:"center",mr:"middle-right",
  bl:"bottom-left",bc:"bottom-center",br:"bottom-right",
};

// Miscellaneous
export const SWATCHES = ["#841116","#f87171","#f472b6","#c084fc","#818cf8","#38bdf8","#34d399","#a3e635","#fbbf24","#fb923c","#1e1e1e","#3a3a3a","#6b6b6b","#b8b8b8","#e5e5e5","#ffffff"];
export const FILTERS = [{id:FLT.AUTO,l:"Auto Adjust"},{id:FLT.BLUR,l:"Blur"},{id:FLT.SHARP,l:"Sharpen"},{id:FLT.GRAY,l:"Grayscale"},{id:FLT.INVERT,l:"Invert"},{id:FLT.SEPIA,l:"Sepia"},{id:FLT.VIGNETTE,l:"Vignette"},{id:FLT.NOISE,l:"Noise"},
  {id:FLT.EMBOSS,l:"Emboss"},{id:FLT.EDGE,l:"Edge Detect"},{id:FLT.POSTERIZE,l:"Posterize"},{id:FLT.THRESHOLD,l:"Threshold"},{id:FLT.CHROMATIC,l:"Chromatic Aberration"},{id:FLT.PIXELATE,l:"Pixelate"}];
export const EXPORTS = [{l:"PNG",m:"image/png",e:"png"},{l:"JPEG",m:"image/jpeg",e:"jpg"},{l:"WebP",m:"image/webp",e:"webp"}];
export const ACCEPT = ".png,.jpg,.jpeg,.webp,.bmp,.gif,.svg,.tiff,.tif,.avif,.ico,.psd,.eps,.ai";
